import { buttonStyle } from "../styles/HomeScreen.styles";
import { useHistory, Link } from "react-router-dom";
import { PrimaryButton } from "@fluentui/react";
import { DetailsList, Selection } from "@fluentui/react";
import { FontSizes, FontWeights } from "@fluentui/theme";
import { SchoolService } from "../services/school.service";
import * as React from "react";
import { useGlobalState } from "../utils/GlobalState";
import { IDetailListSelections, IDetailsListItem } from "../models/details";

export const StudentDetails = () => {
  const schoolService = new SchoolService();
  const _selection: Selection = new Selection({
    onSelectionChanged: () => {
      setDisabledState(true);
      let selection = _getSelectionDetails();
      if (selection) {
        if (selection.selectionCount == 1) {
          setDisabledState(false);
        }
        if (selection.item && selection.item.studentId) {
          setState((prev) => {
            return { ...prev, studentId: selection.item.studentId };
          });
        } else {
          setState((prev) => {
            return { ...prev, studentId: 0 };
          });
        }
      }
    },
  });

  const history = useHistory();
  const acsHelperRoute = () => {
    if (disabledState === false) history.push("/ACSHelper");
  };

  const headerStyle = {
    cellTitle: {
      color: "#1A1F71",
      background: "#F4F2FF",
      border: "8px",
    },
  };

  const columns = [
    {
      styles: headerStyle,
      key: "examDate",
      name: "Exam Date",
      fieldName: "examDate",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      isModalSelection: false,
      styleHeader: "dataListHeader",
    },
    {
      styles: headerStyle,
      key: "studentId",
      name: "Student Number",
      fieldName: "studentId",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      isModalSelection: false,
      styleHeader: "dataListHeader",
    },
    {
      styles: headerStyle,
      key: "studentName",
      name: "Student Name",
      fieldName: "studentName",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      isModalSelection: false,
      styleHeader: "dataListHeader",
    },

    {
      styles: headerStyle,
      key: "courseName",
      name: "Course Name",
      fieldName: "courseName",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
      isModalSelection: false,
      styleHeader: "dataListHeader",
    },
  ];

  const _allItems: any[] = [];
  const [item, setItem] = React.useState({
    items: _allItems,
  });

  const { state, setState } = useGlobalState();
  const [disabledState, setDisabledState] = React.useState(true);

  const accessToken: string | null = localStorage.getItem("accessToken");
  React.useEffect(() => {
    let id: string = state.meetingId!;
    schoolService.getStudentAttendances(id, accessToken).then((data) => {
      setItem((prev) => {
        return { ...prev, items: data };
      });
    });
  }, []);

  function _getSelectionDetails(): IDetailListSelections {
    const selectionCount = _selection.getSelectedCount();
    const selection = _selection.getSelection()[0] as IDetailsListItem;
    let result: IDetailListSelections = {
      selectionCount: selectionCount,
      item: selection,
    };
    return result;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: 50,
            paddingRight: 200,
            paddingLeft: 200,
            fontFamily: "Segoe UI",
          }}
        >
          <div
            style={{
              fontSize: FontSizes.size42,
              fontWeight: FontWeights.semibold,
              textAlign: "center",
              marginTop: 50,
            }}
          >
            HSC Language Oral Exams
          </div>

          <div
            style={{
              fontSize: FontSizes.size28,
              textAlign: "center",
              marginTop: 25,
              marginBottom: 15,
            }}
          >
            Select your student from the list and click Join Meeting
          </div>

          <div className="ms-Grid">
            <div className="ms-Grid-row">
              <DetailsList
                items={item.items}
                columns={columns}
                setKey="set"
                selection={_selection}
              />
            </div>
          </div>
        </div>

        <div style={{ width: "20%", margin: "auto" }}>
          <PrimaryButton
            onClick={acsHelperRoute}
            className={buttonStyle}
            disabled={disabledState}
          >
            Join Meeting
          </PrimaryButton>
        </div>
      </div>
    </>
  );
};

export default StudentDetails;
